const mapStyles = [
  {
    elementType: 'geometry',
    stylers: [{
      color: '#ede6d9',
    }],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [{
      visibility: 'off',
    }],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [{
      visibility: 'off',
    }],
  },
  {
    featureType: 'administrative.locality',
    elementType: 'labels.text.fill',
    stylers: [{
      color: '#ede6d9',
      visibility: 'off',
    }],
  },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [{
      color: '#ede6d9',
      visibility: 'off',
    }],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{
      color: '#ede6d9',
      visibility: 'off',
    }],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [{
      color: '#6b9a76',
      visibility: 'off',
    }],
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [{
      color: '#ede6d9',
      visibility: 'off',
    }],
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [{
      color: '#ede6d9',
      visibility: 'off',
    }],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [{
      color: '#9ca5b3',
      visibility: 'off',
    }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [{
      color: '#ede6d9',
      visibility: 'off',
    }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{
      color: '#ede6d9',
      visibility: 'off',
    }],
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [{
      color: '#f3d19c',
      visibility: 'off',
    }],
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [{
      color: '#2f3948',
      visibility: 'off',
    }],
  },
  {
    featureType: 'transit.station',
    elementType: 'labels.text.fill',
    stylers: [{
      color: '#d59563',
      visibility: 'off',
    }],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{
      color: '#7eaa6d',
    }],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [{
      color: '#7eaa6d',
    }],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.stroke',
    stylers: [{
      color: '#7eaa6d',
    }],
  },
]

export default mapStyles
